import { clientFetch } from '@biw/client-fetch';
import { addError } from 'dux/errors';
import Errors from 'dux/errors/errors';

/*******************************************************************
 * Non-async action types
 *******************************************************************/
export const CATALOG_URL = 'catalogUrl';

/*******************************************************************
 * Action Creators
 *******************************************************************/

export function fetchCatalogUrl() {
    return ( dispatch, getState ) => {

        return clientFetch( { url: `/shop/${getState().user.claims.person_id}`, 
            method: 'post',
            type: CATALOG_URL, 
            catchError: true } )
            .then( ( { shopUrl } ) => {
                return shopUrl;
            } )
            .catch( ( error ) => {
                dispatch( addError( error, Errors.ERROR_SHOP_FETCH_CATALOG_URL ) );
                throw error;
            } );
    };
}
